import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { FullExtentNotifier } from '../notifiers/full-extent-notifier';
import { FullExtentState } from '../states/full-extent-state';

@Injectable({ providedIn: 'root' })
export class FullExtentProvider extends BaseProvider<FullExtentNotifier, FullExtentState> {
  constructor() {
    super(FullExtentNotifier);
  }
}
